/**
 * Normalises transaction data from multiple source formats into a flat array
 * with consistent field names. Handles both columnar (cols/rows) and object
 * array formats, and coerces Debit/Credit types to signed amounts.
 */
export function denormalizeTransactions(txnData) {
  if (!txnData) return [];

  let rows;
  if (Array.isArray(txnData)) {
    rows = txnData;
  } else if (txnData.cols && txnData.rows) {
    rows = txnData.rows.map(row => {
      const obj = {};
      txnData.cols.forEach((col, i) => { obj[col] = row[i]; });
      return obj;
    });
  } else {
    return [];
  }

  return rows.map(t => {
    let amount = t.amount;
    if (t.type === 'Debit')       amount = -Math.abs(amount);
    else if (t.type === 'Credit') amount =  Math.abs(amount);
    return {
      id:             t.id || t.transaction_id,
      date:           t.date || t.transaction_date,
      description:    t.description || t.company,
      amount,
      type:           t.type,
      category:       t.category,
      balance_after:  t.balance_after ?? t.balance,
      rewards_earned: t.rewards_earned,
    };
  });
}
